import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Col,
  NavItem,
  NavLink,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import Popover from "@material-ui/core/Popover";
import Button from "@material-ui/core/Button";
import Zoom from "@material-ui/core/Zoom";
import { Tooltip, Typography } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import ErrorIcon from "@material-ui/icons/Error";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import SendIcon from "@material-ui/icons/Send";
import AlternateEmailIcon from "@material-ui/icons/AlternateEmail";
import { labelHelper } from "../../../../helpers/labelHelper";
import { inputValidator } from "../../../../helpers/inputVaildator";
import CloseIcon from "@material-ui/icons/Close";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import ConfirmModal from "../../../components/ConfirmModal/ConfirmModal";
import { emailActions } from "../../../../store/actions/cms/email/email.action";
import {
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import SentIcon from "../../../../assets/icons/sent_icon.svg";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";

const SendTestEmail = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [addresses, appendAddress] = React.useState([]);
  const [input, setInput] = React.useState("");
  const [modalOpen, toggleModal] = React.useState(false);
  const [sent, setSent] = React.useState(false);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const addAddress = () => {
    if (input.length > 0 && validateEmail(input)) {
      addresses.push(input);
      appendAddress(addresses);
      setInput("");
    }
  };
  const validateEmail = (input) => {
    return inputValidator(input, "email");
  };
  const sendTest = () => {
    const { dispatch, email } = props;
    if (addresses.length === 0) return;
    
    addresses.map((a) => {
      dispatch(
        emailActions.sendTest({
          toAddress: a,
          subject: email.subject ? email.subject : "Email Preview",
          fromAddr: email.fromAddr
            ? email.fromName
              ? `${email.fromName}<${email.fromAddr}>`
              : email.fromAddr
            : "support@inadra.se",
          body: email.body,
        })
      );
    });
    setSent(true);
    handleClose()
    setTimeout(() => setSent(false), 2500);
    //send
  };
  const removeAddress = (index) => {
    let updatedAddresses = Array.from(addresses);
    /*  updatedAddresses =  */ updatedAddresses.splice(index, 1);
    appendAddress(updatedAddresses);
  };
  const renderStatusIcon = () => {
    if (input.length === 0)
      return <AlternateEmailIcon style={{ fontSize: "18px" }} />;
    else if (validateEmail(input)) {
      return <CheckCircleIcon style={{ fontSize: "18px", color: "#1aa01a" }} />;
    } else return <ErrorIcon style={{ fontSize: "18px", color: "#cd3535" }} />;
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  return (
    <React.Fragment>
      <NavItem>
        <Tooltip
          TransitionComponent={Zoom}
          placement="top"
          title={labelHelper.getLabel("SendTest")}
        >
          <NavLink
            disabled={props.isSavable}
            className="nav-toolbar-item"
            onClick={handleClick}
          >
            <SendIcon className=" editor-toolbar-icon" />
          </NavLink>
        </Tooltip>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          style={{ zIndex: 10000, padding: "10px", marginLeft: "-11px" }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          {/*    <Row style={{ margin: "10px", display: 'block' }}>
                        <Col style={{ padding: "0px" }}>
                            <Label><SystemLabel name="FromAddress" /></Label>
                        </Col>
                        <Col style={{ padding: "0px" }}>
                            <InputGroup>
                                <Input autoComplete="jirango-nofill" onChange={(e) => setInput(e.target.value)} style={{
                                    height: '38px', ['&:focus']: {
                                        boxShadow: 'none',
                                        outline: 0
                                    }
                                }} value={input} />
                            </InputGroup>
                        </Col>
                        <p
                            className="text-muted"
                            style={{ lineHeight: "initial", marginTop: "5px" }}
                        >
                            <SystemLabel name="Optional" />
                        </p>
                    </Row> */}
          <Row style={{ margin: "10px", display: "block" }}>
            {/*   <Col style={{ padding: "0px" }}>
                            <Label><SystemLabel name="AddAddress" /></Label>
                        </Col> */}
            <Col style={{ padding: "0px" }}>
              <InputGroup>
                <InputGroupAddon addonType="append">
                  <InputGroupText
                    className="jirango-prepend"
                    style={{
                      backgroundColor: "#fff",
                      border: "1px solid #e4e7ea",
                    }}
                  >
                    {renderStatusIcon()}
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  autoComplete="jirango-nofill"
                  onChange={(e) => setInput(e.target.value)}
                  style={{
                    height: "38px",
                    ["&:focus"]: {
                      boxShadow: "none",
                      outline: 0,
                    },
                  }}
                  value={input}
                />
                <InputGroupAddon addonType="append">
                  <InputGroupText
                    className="jirango-prepend"
                    style={{
                      backgroundColor: "#fff",
                      cursor:
                        input.length !== 0 && validateEmail(input)
                          ? "pointer"
                          : "not-allowed",
                      /* color: input.length !== 0 && validateEmail(input) ? 'inital' : 'gainsboro' */ /* , */ border:
                        "1px solid #e4e7ea",
                    }}
                  >
                    <AddIcon
                      /* style={{ color: input.length !== 0 && validateEmail(input) ? 'gray' : 'gainsboro' }} */ onClick={
                        addAddress
                      }
                    />
                  </InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            </Col>
          </Row>
          {addresses.length > 0
            ? addresses.map((a, i) => {
                return (
                  <div
                    key={i}
                    style={{
                      padding: "10px 15px",
                      textAlign: "left",
                      position: "relative",
                      background: "#e8f5ff",
                      margin: "10px",
                    }}
                  >
                    {a}
                    <CloseIcon
                      onClick={() => removeAddress(i)}
                      style={{
                        position: "absolute",
                        left: "91%",
                        top: "32%",
                        fontSize: "15px",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                );
              })
            : null}
          {addresses.length > 0 ? (
            <Row>
              <Col>
                <Button
                  style={{
                    //width: "100%",
                    background: "#20a8d8",
                    color: "#fff",
                    borderRadius: 0,
                    margin: "0px 10px 10px",
                    width: "calc(100% - 20px)",
                  }}
                  onClick={sendTest}
                  color="primary"
                >
                  {/*   <SendIcon style={{ fontSize: '18px' }} /> */}
                  <SystemLabel name="Send" />
                </Button>
              </Col>
            </Row>
          ) : null}
        </Popover>
        {/*   {sent ? <SendConfirmationModal /> : null} */}
        {/* <ConfirmModal
          open={modalOpen}
          onCancel={() => toggleModal(false)}
          onAction={sendTest}
          text={"AreYouSureYouWannaSend"}
        /> */}
      </NavItem>
    </React.Fragment>
  );
};

function mapStateToProps(state) {
  return {
    email: state.email,
    isSavable: state.email.isSavable,
  };
}
export default connect(mapStateToProps)(SendTestEmail);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const SendConfirmationModal = (props) => {
  return (
    <React.Fragment>
      <Dialog
        open={true}
        TransitionComponent={Transition}
        keepMounted
        style={{ zIndex: 1000000 }}
        onClose={() => null}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          {" "}
          <img
            src={SentIcon}
            /* className="animated fadeIn"  */ width="45"
            height="45"
          ></img>
          {"  "}
          <SystemLabel name="MailSent"></SystemLabel>
        </DialogTitle>
      </Dialog>
    </React.Fragment>
  );
};
